import { AtivoVisualizadorComponent } from './ativo-visualizador/ativo-visualizador.component';
import {AppSharedModule} from '../app-shared.module';
import {NgModule} from '@angular/core';
import {ComponentsModule} from '../components/components.module';
import {AplicacaoMonitoramentoVisualizadorComponent} from './aplicacao-monitoramento-visualizador/aplicacao-monitoramento-visualizador.component';

@NgModule({
  imports: [
    AppSharedModule,
    ComponentsModule,
  ],
  declarations: [
    AplicacaoMonitoramentoVisualizadorComponent,
    AtivoVisualizadorComponent
  ],
  exports: [
    AplicacaoMonitoramentoVisualizadorComponent,
    AtivoVisualizadorComponent
  ]
})
export class MonitoramentoModule {}
